export default __webpack_public_path__ + "static/CSICon-Map-8962f14d7e76e7eb29b48dfba99375c4.jpg";